var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIpSwimwear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 4v7m20-7v7M12 31h24v5c-3 0-10 3-10 8h-5c0-5-6-8-9-8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 18,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 18,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 18h6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIpSwimwear);
export default __webpack_public_path__ + "static/media/icon-ip-swimwear.1cc9c194cab14ee878964c5649f450d9.svg";
export { ForwardRef as ReactComponent };